const BASE_URL = `${process.env.REACT_APP_API_URL}api/`;

export const ENDPOINTS = {
    // Auth
    AUTH: {
        LOGIN: `${BASE_URL}users`,
        CONFIRM_AUTH: `${BASE_URL}users/confirm-auth`,
        LOGOUT: `${BASE_URL}auth/logout`,
        CHECK: `${BASE_URL}auth/check`,
        REFRESH: `${BASE_URL}auth/refresh`,
    },

    // Registration
    REGISTER: {
        QUESTIONS: `${BASE_URL}register/questions`,
        SUBMIT: `${BASE_URL}register/check-answer`,
        CREATE_ACCOUNT: `${BASE_URL}register/create-acc`,
        SEND_VERIFY_CODE: `${BASE_URL}register/send-verify-code`,
        SUBMIT_VERIFY_CODE: `${BASE_URL}register/submit-verify-code`,
    },

    // Recovery
    RECOVERY: {
        REQUEST: `${BASE_URL}recovery/request`,
        VERIFY: `${BASE_URL}recovery/verify`,
        RESET: `${BASE_URL}recovery/reset`,
    },

    // 2FA
    TWO_FACTOR: {
        CHECK: `${BASE_URL}google-two-factor/check`,
        SETUP: `${BASE_URL}google-two-factor/setup`,
        VERIFY: `${BASE_URL}google-two-factor/verify`,
        NEW_SECRET_KEY: `${BASE_URL}google-two-factor/new-secret-key`,
        DISABLE_TWO_AUTH: `${BASE_URL}google-two-factor/disable-two-auth`,
    },

    // UCP - User Control Panel
    UCP: {
        GET_CHARACTERS: `${BASE_URL}ucp/get-user-characters`,
        CREATE_CHARACTER: `${BASE_URL}ucp/create-character`,
        DELETE_CHARACTER: `${BASE_URL}ucp/delete-character`,
        RETEST_CHARACTER: `${BASE_URL}ucp/retest-character`,
        GET_STATS: `${BASE_URL}ucp/get-statistics`,
        GET_DONATE: `${BASE_URL}ucp/get-donate`,
        UPDATE_SETTINGS: `${BASE_URL}ucp/update-settings`,
        CHANGE_PASSWORD: `${BASE_URL}ucp/change-password`,
        CHANGE_USER_PASSWORD: `${BASE_URL}ucp/change-user-password`,
        GET_ROLE_SITUATIONS: `${BASE_URL}ucp/get-role-situations`,
        GET_CHARACTER_INFO: `${BASE_URL}ucp/get-character-info`,
        GET_SHOP_ITEMS: `${BASE_URL}ucp/get-shop-items`,
        GET_FAVOURITE_ITEMS: `${BASE_URL}ucp/get-favourite-items`,
        PUT_IN_FAVOURITES: `${BASE_URL}ucp/put-in-favourites`,
        DELETE_FROM_FAVOURITES: `${BASE_URL}ucp/delete-from-favourites`,
        GET_SHOP_ITEM: `${BASE_URL}ucp/get-shop-item`,
        GET_SHOP_ITEM_STATS: `${BASE_URL}ucp/get-shop-item-stats`,
        BUY_ITEM: `${BASE_URL}ucp/buy-item`,
        GET_NOTIFICATIONS: `${BASE_URL}ucp/get-notifications`,
        GET_ROLE_SITUATION: `${BASE_URL}ucp/get-role-situation`,
        GET_USER_INFO: `${BASE_URL}ucp/get-user-info`,
        CHECK_ADMIN: `${BASE_URL}acp/check-admin`,
    },

    // ACP - Admin Control Panel
    ACP: {
        CHECK_ADMIN: `${BASE_URL}acp/check-admin`,
        GET_APPLICATIONS: `${BASE_URL}acp/applications`,
        GET_CHARACTERS: `${BASE_URL}acp/characters`,
        GET_USERS: `${BASE_URL}acp/users`,
        APPROVE_APPLICATION: `${BASE_URL}acp/applications/approve`,
        REJECT_APPLICATION: `${BASE_URL}acp/applications/reject`,
    },

    // Shop
    SHOP: {
        CATEGORIES: `${BASE_URL}shop/categories`,
        PRODUCTS: `${BASE_URL}shop/products`,
        PURCHASE: `${BASE_URL}shop/purchase`,
        GET_FAVORITES: `${BASE_URL}shop/favorites`,
        ADD_FAVORITE: `${BASE_URL}shop/favorites/add`,
        REMOVE_FAVORITE: `${BASE_URL}shop/favorites/remove`,
    },

    // Payments
    PAYMENTS: {
        GET_COURSES: `${BASE_URL}payments/get-courses`,
        ADD_PAYMENT: `${BASE_URL}payments/add-payment`,
    },
};

export default ENDPOINTS;
